import React, { useContext, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { BetaContext } from '../context/BetaContext';
import './BetaAuth.css';

const BetaLoginPage = () => {
  const navigate = useNavigate();
  const { login } = useContext(BetaContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await login({ email, password });
      navigate('/user-dashboard');
    } catch (err) {
      setError('Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="beta-auth">
      <div className="beta-auth__card">
        <h2>RS Education Beta Login</h2>
        {error && <div className="beta-auth__error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <label>
            Email
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </label>
          <label>
            Password
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </label>
          <button type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        <p>
          Need an invite? <Link to="/beta/register">Register here</Link>
        </p>
      </div>
    </div>
  );
};

export default BetaLoginPage;
